<template>
  <div class="shift-table">
    <div class="shift-table-scroll">
    <el-skeleton :loading="loading" animated>
      <template #template>
        <div v-for="n in 3" :key="n" class="user-row skeleton">
          <div class="avatar" />
          <div class="info">
            <div class="name" />
            <div class="shift" v-for="i in 2" :key="i" />
          </div>
        </div>
      </template>

      <template #default>
        <div class="shift-table-desktop">
          <el-table :data="users" style="width: 100%">
          <el-table-column label="Сотрудник" min-width="320">
            <template #default="{ row }">
              <div class="shift-employee-cell">
                <el-avatar :size="34" v-if="row.avatar" :src="row.avatar" />
                <el-avatar :size="34" v-else>{{ getInitials(getEmployeeLabel(row)) }}</el-avatar>
                <span class="shift-employee-name">{{ getEmployeeLabel(row) }}</span>
              </div>
            </template>
          </el-table-column>

          <!-- Локация -->
          <el-table-column label="Локация" min-width="320" class-name="shift-location-column">
            <template #default="{ row }">
              <div class="shift-location-cell">
                <el-icon class="shift-location-icon"><Location /></el-icon>
                <span class="shift-location-text">{{ getLocationLabel(row) }}</span>
              </div>
            </template>
          </el-table-column>

          <!-- Смены -->
          <el-table-column label="Смены" width="220" align="center" class-name="shift-shifts-column">
            <template #default="{ row }">
              <el-button class="show-shifts-btn" size="small" type="primary" @click="openCalendar(row)">
                Показать смены
              </el-button>
            </template>
          </el-table-column>

          <!-- Действия -->
          <el-table-column v-if="type === 'current'" label="Действия" width="160" align="center" class-name="shift-actions-column">
            <template #default="{ row }">
              <div class="shift-actions-cell">
                <el-button
                  type="primary"
                  size="small"
                  :icon="Edit"
                  circle
                  @click="openCalendar(row, true)"
                />
                <el-button
                  type="danger"
                  size="small"
                  :icon="Delete"
                  circle
                  @click="$emit('delete-shifts', row)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>

        <div class="shift-table-mobile-list">
          <div :class="['shift-mobile-head', { 'shift-mobile-head--readonly': type !== 'current' }]">
            <span class="shift-mobile-head__cell shift-mobile-head__cell--employee">Сотрудник</span>
            <span class="shift-mobile-head__cell shift-mobile-head__cell--location">Локация</span>
            <span class="shift-mobile-head__cell shift-mobile-head__cell--shifts">Смены</span>
            <span v-if="type === 'current'" class="shift-mobile-head__cell shift-mobile-head__cell--actions">Действия</span>
          </div>

          <article
            v-for="row in users"
            :key="`mobile-${row.id}-${row.city_id || ''}-${row.branch_id || ''}-${row.room_id || ''}`"
            :class="['shift-mobile-row', { 'shift-mobile-row--readonly': type !== 'current' }]"
          >
            <div class="shift-mobile-cell shift-mobile-cell--employee">
              <div class="shift-employee-cell">
                <el-avatar :size="32" v-if="row.avatar" :src="row.avatar" />
                <el-avatar :size="32" v-else>{{ getInitials(getEmployeeLabel(row)) }}</el-avatar>
                <span class="shift-employee-name">{{ getEmployeeLabel(row) }}</span>
              </div>
            </div>

            <div class="shift-mobile-cell shift-mobile-cell--location">
              <span class="shift-mobile-location-text">{{ getLocationLabel(row) }}</span>
            </div>

            <div class="shift-mobile-cell shift-mobile-cell--shifts">
              <el-button class="show-shifts-btn shift-mobile-show-btn" size="small" type="primary" @click="openCalendar(row)">
                Смены
              </el-button>
            </div>

            <div v-if="type === 'current'" class="shift-mobile-cell shift-mobile-cell--actions">
              <div class="shift-actions-cell shift-actions-cell--mobile">
                <el-button
                  type="primary"
                  size="small"
                  :icon="Edit"
                  circle
                  @click="openCalendar(row, true)"
                />
                <el-button
                  type="danger"
                  size="small"
                  :icon="Delete"
                  circle
                  @click="$emit('delete-shifts', row)"
                />
              </div>
            </div>
          </article>
        </div>
      </template>
    </el-skeleton>
    </div>
  </div>
  <el-dialog
    v-model="calendarVisible"
    class="shift-view-dialog"
    :width="viewDialogWidth"
    :close-on-click-modal="false"
    destroy-on-close
    @closed="selectedUser = null">
    <template #header="{ titleId, titleClass }">
      <div :id="titleId" :class="titleClass" class="shift-view-dialog-header">
        <span class="shift-view-dialog-title">{{ selectedUser ? `Смены-${getEmployeeLabel(selectedUser)}` : 'Смены-сотрудник' }}</span>
        <el-button
          v-if="calendarMode === 'edit'"
          type="primary"
          plain
          size="small"
          class="shift-view-dialog-template-btn"
          @click="applyTemplateDialogVisible = true"
        >
          Применить шаблон
        </el-button>
      </div>
    </template>

    <shift-calendar
      :shifts="selectedUser?.shifts || []"
      :user-name="selectedUser?.name || ''"
      :mode="calendarMode"
      :working-hours="selectedUser?.working_hours || null"
      :unrestricted-hours="selectedUser?.branch_id == null"
      @update:shifts="val => selectedUser.shifts = val"
    />
    <template #footer v-if="calendarMode === 'edit'">
      <div class="shift-view-dialog-footer-actions">
        <el-button
          type="primary"
          plain
          size="small"
          class="shift-view-dialog-template-btn shift-view-dialog-template-btn--footer"
          @click="applyTemplateDialogVisible = true"
        >
          Применить шаблон
        </el-button>
        <el-button class="shift-view-dialog-save-btn" type="primary" @click="$emit('update-shifts', selectedUser)">
          Обновить смены
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog
    v-model="applyTemplateDialogVisible"
    title="Применить шаблон"
    width="360"
    class="shift-template-apply-dialog"
  >
    <el-select v-model="selectedTemplateId" placeholder="Выберите шаблон" style="width: 100%; margin-bottom: 12px;">
      <el-option
        v-for="t in templates"
        :key="t.id"
        :label="t.name"
        :value="t.id"
      />
    </el-select>
    <el-date-picker
      v-model="dateRange"
      type="daterange"
      start-placeholder="Дата начала"
      end-placeholder="Дата окончания"
      :disabled-date="disabledPastDates"
      range-separator="—"
      unlink-panels
      style="width: 100%; margin-bottom: 12px;"
    />
    <div class="d-flex justify-content-end">
      <el-button type="primary" @click="applyTemplateSubmit">Применить</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ShiftCalendar from './ShiftCalendar.vue';
import { Delete, Edit, Location } from '@element-plus/icons-vue'
import { mapState } from 'vuex'
import { generateShiftsFromTemplate } from '@/components/util/scheduleTemplate'

export default {
  emits: ['update-shifts', 'delete-shifts', 'apply-template'],
  computed: {
    ...mapState('cities', ['cities']),
    ...mapState('users', ['employees']),
    ...mapState('auth', ['user']),
    ...mapState('schedules', { templates: state => state.schedulesTemplates }),
    Delete() { return Delete },
    Edit() { return Edit },
    Location() { return Location },
    viewDialogWidth() {
      if (typeof window !== 'undefined' && window.innerWidth <= 480) return 'calc(100vw - 20px)'
      if (typeof window !== 'undefined' && window.innerWidth <= 768) return 'calc(100vw - 28px)'
      if (typeof window !== 'undefined' && window.innerWidth <= 1100) return '76vw'
      return '640px'
    },
  },
  components: { ShiftCalendar, Location },
  props: {
    users: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    type: { type: String, default: 'current' }, // current | history
  },
  data() {
    return {
      calendarVisible: false,
      selectedUser: null,
      calendarMode: 'view',
      applyTemplateDialogVisible: false,
      selectedTemplateId: null,
      dateRange: [],
    };
  },
  methods: {
    getInitials(name) {
      if (!name || typeof name !== 'string') return ''
      const parts = name.trim().split(/\s+/)
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
    },
    getEmployeeLabel(row) {
      const storeUser = (this.employees || []).find(item => Number(item.id) === Number(row?.id))
      if (row?.email) return row.email
      if (storeUser?.email) return storeUser.email
      if (Number(this.user?.id) === Number(row?.id) && this.user?.email) return this.user.email
      return row?.name || ''
    },
    getLocationLabel(row) {
      const parts = [row.city_name || row.city_id, row.branch_name || row.branch_id, row.room_name || row.room_id]
        .filter(Boolean)
      return parts.join(' ↔ ')
    },
    resolveWorkingHours(user) {
      if (user.branch_id == null) return { start: '09:00', end: '18:00' };
      const list = Array.isArray(this.cities) ? this.cities : (Array.isArray(this.cities?.list) ? this.cities.list : []);
      if (!list || !list.length) return null;

      const cityId = user.city_id;
      const branchId = user.branch_id;
      const roomId = user.room_id;

      const city = list.find(c => c.id == cityId);
      if (!city) return null;

      const branch = city.children?.find(b => b.id == branchId);
      if (!branch) return null;

      if (roomId) {
        const room = branch.children?.find(r => r.id == roomId);
        if (room && room.working) return room.working;
      }

      return branch.working || null;
    },
    openCalendar(user, isEdit = false) {
      const workingHours = this.resolveWorkingHours(user);
      this.selectedUser = {
        ...user,
        working_hours: workingHours
      };
      this.calendarMode = isEdit ? 'edit' : 'view';
      this.calendarVisible = true;
    },
    disabledPastDates(date) {
      const today = new Date();
      today.setHours(0,0,0,0);
      return date.getTime() < today.getTime();
    },
    applyTemplateSubmit() {
      if (!this.selectedTemplateId || !this.dateRange.length || !this.selectedUser) {
        this.$message.error('Выберите шаблон и диапазон дат');
        return;
      }

      const template = this.templates.find(t => t.id === this.selectedTemplateId);
      if (!template) {
        this.$message.error('Шаблон не найден');
        return;
      }

      const [startDate, endDate] = this.dateRange;
      const workingHours = this.selectedUser.working_hours;

      if (!workingHours) {
        this.$message.error('Не указаны рабочие часы для сотрудника');
        return;
      }

      // 1️⃣ Удаляем все смены, которые начинаются с выбранной даты
      this.selectedUser.shifts = (this.selectedUser.shifts || []).filter(s => s.date < startDate);

      // 2️⃣ Генерируем новые смены по шаблону
      const newShifts = generateShiftsFromTemplate(
        template,
        startDate,
        endDate,
        workingHours
      );

      // 3️⃣ Добавляем их к текущим
      this.selectedUser.shifts.push(...newShifts);

      // 4️⃣ Уведомление
      this.$message.success('Шаблон успешно применён');

      // 5️⃣ Очистка формы
      this.selectedTemplateId = null;
      this.dateRange = [];
      this.applyTemplateDialogVisible = false;
    },
  }
};
</script>
<style scoped>
.shift-employee-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.shift-employee-name {
  color: #22c0ff !important;
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 38px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-family: var(--ui-font-family-base) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1 !important;
}

.shift-location-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  color: #22c0ff !important;
  min-height: 52px;
  padding: 0;
  overflow: visible;
}

.shift-location-icon {
  font-size: 14px;
  flex-shrink: 0;
  color: #22c0ff !important;
}

.shift-location-text {
  color: #22c0ff !important;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  text-align: center;
  padding: 0;
  font-family: var(--ui-font-family-base) !important;
  font-size: 16px !important;
  font-weight: 400 !important;
}

.loc-arrow {
  color: rgba(0, 195, 254, 0.6);
  margin: 0 1px;
}

.shift-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.shift-table-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.shift-table :deep(.el-table__body-wrapper),
.shift-table :deep(.el-table__inner-wrapper),
.shift-table :deep(.el-table__header-wrapper) {
  overflow-x: hidden !important;
}

.shift-table-desktop {
  display: block;
  width: 100%;
}

.shift-table-mobile-list {
  display: none;
}

.shift-mobile-head,
.shift-mobile-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.45fr) minmax(74px, 88px) 64px;
  gap: 6px;
  align-items: center;
}

.shift-mobile-head--readonly,
.shift-mobile-row--readonly {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.55fr) minmax(78px, 94px);
}

.shift-mobile-head {
  padding: 0 10px 6px;
}

.shift-mobile-head__cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.shift-mobile-row {
  min-height: 66px;
  padding: 0 10px;
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  border-radius: 12px !important;
  overflow: visible;
}

.shift-mobile-row + .shift-mobile-row {
  margin-top: 10px;
}

.shift-mobile-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d7e7ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 12px;
}

.shift-mobile-cell--employee {
  justify-content: flex-start;
}

.shift-mobile-cell--location {
  justify-content: flex-start;
  text-align: left;
}

.shift-mobile-location-text {
  display: block;
  width: 100%;
  overflow: hidden;
  line-height: 1.08;
  text-align: left;
  white-space: normal;
  color: #22c0ff !important;
  padding: 0;
  text-overflow: unset;
  word-break: break-word;
}

.shift-mobile-cell--actions {
  overflow: visible;
  justify-content: flex-end;
  padding-right: 4px;
}

.shift-actions-cell--mobile {
  gap: 4px;
  width: auto;
  justify-content: flex-end;
  flex-shrink: 0;
}

.shift-view-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.shift-view-dialog-title {
  display: block;
  font-family: var(--ui-font-family-base);
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  color: var(--cal-text-inverse);
}

.shift-table :deep(.el-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: transparent;
  --el-table-text-color: var(--cal-text-regular);
  --el-table-header-text-color: var(--cal-text-inverse);
  background: transparent;
  color: var(--cal-text-regular);
  border: 0;
  width: 100%;
  border-radius: 0;
  overflow: visible;
  table-layout: fixed;
  min-width: 1080px;
}

.shift-table :deep(.el-table__header colgroup col:nth-child(1)),
.shift-table :deep(.el-table__body colgroup col:nth-child(1)) {
  width: 25.7% !important;
}

.shift-table :deep(.el-table__header colgroup col:nth-child(2)),
.shift-table :deep(.el-table__body colgroup col:nth-child(2)) {
  width: 33.1% !important;
}

.shift-table :deep(.el-table__header colgroup col:nth-child(3)),
.shift-table :deep(.el-table__body colgroup col:nth-child(3)) {
  width: 23.6% !important;
}

.shift-table :deep(.el-table__header colgroup col:nth-child(4)),
.shift-table :deep(.el-table__body colgroup col:nth-child(4)) {
  width: 18% !important;
}

.shift-table :deep(.el-table::before),
.shift-table :deep(.el-table__inner-wrapper::before) {
  display: none;
}

.shift-table :deep(.el-table table) {
  border-collapse: collapse;
  border-spacing: 0;
}

.shift-table :deep(.el-table th.el-table__cell) {
  background: transparent;
  border-bottom: 0;
  padding: 0 6px 12px;
}

.shift-table :deep(.el-table th.el-table__cell .cell) {
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 21px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.shift-table :deep(.el-table td.el-table__cell) {
  background: transparent;
  border-bottom: 0;
  padding: 0 6px 9px;
}

.shift-table :deep(.el-table td.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  border-radius: 8px !important;
  padding: 0 18px !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 16px !important;
  line-height: 1 !important;
}

.shift-table :deep(.shift-location-column .cell),
.shift-table :deep(.shift-shifts-column .cell),
.shift-table :deep(.shift-actions-column .cell) {
  justify-content: center !important;
}

.shift-table :deep(.shift-location-column .cell) {
  min-height: 52px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  overflow: visible !important;
}

.shift-table :deep(.el-avatar) {
  background: var(--appointment-primary);
  color: var(--appointment-primary-text);
  width: 28px !important;
  height: 28px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  flex-shrink: 0 !important;
}

.shift-table :deep(.el-button--primary:not(.is-plain)) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.shift-table :deep(.el-button--danger) {
  background: var(--appointment-control);
  border-color: transparent;
  color: #ff8d8d;
}

.shift-table :deep(.el-button.is-circle) {
  background: #0c224b !important;
  border: none !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  color: #244885 !important;
  width: 34px !important;
  height: 34px !important;
  min-width: 34px !important;
  padding: 0 !important;
}

.shift-table :deep(.el-button.is-circle:hover) {
  background: #1b3f7a !important;
}

.shift-table :deep(.el-button.is-circle.el-button--primary) {
  color: #244885 !important;
}

.shift-table :deep(.el-button.is-circle.el-button--primary:hover) {
  color: #22c0ff !important;
}

.shift-table :deep(.el-button.is-circle.el-button--danger) {
  color: #244885 !important;
}

.shift-table :deep(.el-button.is-circle.el-button--danger:hover) {
  color: #ff5858 !important;
}

.shift-table :deep(.show-shifts-btn.el-button) {
  min-height: 32px !important;
  padding: 0 18px !important;
  border-radius: 7px !important;
  background: #22c0ff !important;
  border: none !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 1 !important;
}

.shift-table :deep(.show-shifts-btn.el-button:hover) {
  background: #00b0e5 !important;
}

.shift-table :deep(.el-input__wrapper),
.shift-table :deep(.el-select__wrapper),
.shift-table :deep(.el-date-editor.el-input__wrapper) {
  background: var(--appointment-value);
  box-shadow: 0 0 0 1px var(--cal-border) inset;
}

.shift-table :deep(.el-input__inner),
.shift-table :deep(.el-select__placeholder),
.shift-table :deep(.el-select__selected-item),
.shift-table :deep(.el-range-input) {
  color: var(--cal-text-inverse);
}

.shift-table :deep(.el-button--default) {
  background: var(--appointment-secondary);
  border-color: transparent;
  color: var(--appointment-secondary-text);
}

.shift-table :deep(.el-dialog__footer .el-button--primary),
.shift-table :deep(.el-dialog__header .el-button--primary),
.shift-table :deep(.el-dialog .el-button--primary.is-plain) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}
@media (max-width: 991px) {
  .shift-table-desktop {
    display: none !important;
  }

  .shift-table-mobile-list {
    display: block !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
  }

  .shift-table-scroll {
    overflow: visible;
  }

  .shift-mobile-head,
  .shift-mobile-row {
    width: max-content;
    grid-template-columns: 240px 240px 118px 74px;
    gap: 8px;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .shift-mobile-head--readonly,
  .shift-mobile-row--readonly {
    grid-template-columns: 240px 240px 118px;
  }

  .shift-mobile-head {
    padding: 0 0 6px;
  }

  .shift-mobile-head__cell {
    min-height: 42px;
    padding: 0 12px;
    justify-content: center !important;
    text-align: center !important;
    background:
      linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
      linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
    border-radius: 8px !important;
    color: #ffffff !important;
    font-family: var(--ui-font-family-base) !important;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0;
    text-transform: none;
  }

  .shift-mobile-row {
    min-height: 0;
    padding: 0;
  }

  .shift-mobile-cell {
    min-height: 44px;
    padding: 0 10px;
    font-size: 12px;
    background:
      linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
    box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
    border-radius: 8px !important;
  }

  .shift-mobile-cell--employee,
  .shift-mobile-cell--location,
  .shift-mobile-cell--shifts,
  .shift-mobile-cell--actions {
    grid-column: auto;
    grid-row: auto;
  }

  .shift-mobile-cell--employee,
  .shift-mobile-cell--location {
    justify-content: center;
  }

  .shift-mobile-cell--shifts,
  .shift-mobile-cell--actions {
    justify-content: center;
  }

  .shift-table :deep(.shift-mobile-row .el-avatar) {
    width: 22px !important;
    height: 22px !important;
    font-size: 11px !important;
  }

  .shift-employee-cell {
    justify-content: center;
    gap: 6px !important;
  }

  .shift-employee-name,
  .shift-mobile-location-text {
    font-size: 12px !important;
    max-width: 100%;
  }

  .shift-mobile-location-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  .shift-table :deep(.show-shifts-btn.el-button) {
    min-height: 28px !important;
    padding: 0 10px !important;
    font-size: 11px !important;
  }

  .shift-table :deep(.shift-mobile-row .el-button.is-circle) {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
  }
}
@media (max-width: 480px) {
  .shift-mobile-head,
  .shift-mobile-row {
    grid-template-columns: 228px 228px 112px 70px;
    gap: 6px;
  }

  .shift-mobile-head--readonly,
  .shift-mobile-row--readonly {
    grid-template-columns: 228px 228px 112px;
  }

  .shift-mobile-head {
    padding: 0 0 6px;
  }

  .shift-mobile-head__cell {
    min-height: 38px;
    font-size: 14px;
    padding: 0 10px;
  }

  .shift-employee-name {
    font-size: 11px !important;
  }

  .shift-mobile-location-text {
    font-size: 10px !important;
  }

  .shift-mobile-cell {
    min-height: 42px;
    padding: 0 8px;
  }

  .shift-table :deep(.shift-mobile-row .el-button.is-circle) {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .shift-table :deep(.show-shifts-btn.el-button) {
    font-size: 10px !important;
    padding: 0 8px !important;
    min-height: 26px !important;
  }
}
</style>
<style>
.shift-view-dialog,
.shift-view-dialog.el-dialog {
  background-color: #1a458c !important;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #14387a 0%, #1f4f99 100%) !important;
  background-image:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #14387a 0%, #1f4f99 100%) !important;
  border: 1px solid rgba(44, 86, 163, 0.9);
  box-shadow: 0 28px 80px rgba(0, 6, 19, 0.48);
  border-radius: 0 !important;
  max-width: min(640px, calc(100vw - 40px)) !important;
  width: min(640px, calc(100vw - 40px)) !important;
}

.shift-view-dialog,
.shift-template-apply-dialog {
  font-family: var(--ui-font-family-base);
}

.shift-view-dialog .el-dialog__header,
.shift-view-dialog .el-dialog__body,
.shift-view-dialog .el-dialog__footer,
.shift-template-apply-dialog .el-dialog__header,
.shift-template-apply-dialog .el-dialog__body,
.shift-template-apply-dialog .el-dialog__footer {
  background: transparent;
}

.shift-view-dialog .el-dialog__header {
  padding: 16px 20px 4px;
}

.shift-view-dialog .el-dialog__body {
  padding: 0 20px 16px;
}

.shift-view-dialog .el-dialog__footer {
  padding: 4px 20px 16px;
}

.shift-view-dialog .el-dialog__title,
.shift-template-apply-dialog .el-dialog__title {
  color: var(--cal-text-inverse);
}

.shift-view-dialog .el-dialog__headerbtn,
.shift-template-apply-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 16px;
}

.shift-view-dialog .el-dialog__close,
.shift-template-apply-dialog .el-dialog__close {
  color: #031230;
  font-size: 22px;
  font-weight: 700;
}

.shift-template-apply-dialog {
  background: var(--appointment-panel);
  border: 1px solid var(--cal-border);
  box-shadow: var(--cal-shadow-card);
}

.shift-template-apply-dialog .el-input__wrapper,
.shift-template-apply-dialog .el-select__wrapper,
.shift-template-apply-dialog .el-date-editor.el-input__wrapper {
  background: var(--appointment-value);
  box-shadow: 0 0 0 1px var(--cal-border) inset;
}

.shift-template-apply-dialog .el-input__inner,
.shift-template-apply-dialog .el-select__placeholder,
.shift-template-apply-dialog .el-select__selected-item,
.shift-template-apply-dialog .el-range-input {
  color: var(--cal-text-inverse);
}

.shift-template-apply-dialog .el-button--primary {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.shift-view-dialog-template-btn.el-button,
.shift-view-dialog-save-btn.el-button {
  min-height: 38px !important;
  padding: 0 16px !important;
  border-radius: 0 !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.shift-view-dialog-title {
  font-size: 28px !important;
  line-height: 1 !important;
  max-width: 100%;
}

.shift-view-dialog-header > .shift-view-dialog-template-btn:not(.shift-view-dialog-template-btn--footer) {
  display: none !important;
}

.shift-view-dialog-template-btn.el-button {
  background: #102a5d !important;
  border: none !important;
  box-shadow: inset 0 0 0 1px rgba(72, 124, 221, 0.3) !important;
  color: #22c0ff !important;
}

.shift-view-dialog-save-btn.el-button {
  background: #22c0ff !important;
  border: none !important;
  color: #ffffff !important;
}

.shift-view-dialog-footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
}

.shift-view-dialog-template-btn--footer.el-button {
  min-height: 38px !important;
  padding: 0 16px !important;
  font-size: 13px !important;
  transform: none !important;
}

@media (max-width: 860px) {
  .shift-view-dialog {
    width: min(640px, calc(100vw - 24px)) !important;
    max-width: min(640px, calc(100vw - 24px)) !important;
  }

  .shift-view-dialog .el-dialog__header,
  .shift-view-dialog .el-dialog__body,
  .shift-view-dialog .el-dialog__footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 768px) {
  .shift-view-dialog {
    width: calc(100vw - 18px) !important;
  }

  .shift-view-dialog .el-dialog__header {
    padding: 14px 14px 6px;
  }

  .shift-view-dialog .el-dialog__body {
    padding: 0 14px 10px;
    max-height: calc(100vh - 142px);
    overflow-y: auto;
  }

  .shift-view-dialog .el-dialog__footer {
    padding: 6px 14px 12px;
  }
}

@media (max-width: 480px) {
  .shift-view-dialog {
    width: calc(100vw - 20px) !important;
    max-width: calc(100vw - 20px) !important;
    margin: 0 !important;
  }

  .shift-view-dialog .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
  }

  .shift-view-dialog-header {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    padding-right: 28px;
  }

  .shift-view-dialog-title {
    font-size: 16px !important;
    line-height: 1.08;
    max-width: 100%;
    word-break: break-word;
  }

  .shift-view-dialog-template-btn.el-button,
  .shift-view-dialog-save-btn.el-button {
    min-height: 28px !important;
    padding: 0 9px !important;
    font-size: 10px !important;
  }

  .shift-view-dialog-footer-actions {
    gap: 8px;
    margin-top: 2px;
  }

  .shift-view-dialog-template-btn--footer.el-button {
    transform: none !important;
  }

  .shift-view-dialog .el-dialog__body {
    padding: 0 10px 8px !important;
  }
  .shift-view-dialog .el-dialog__footer {
    padding: 6px 10px 10px !important;
  }
}

@media (max-width: 390px) {
  .shift-view-dialog-title {
    font-size: 15px !important;
  }

  .shift-view-dialog-template-btn.el-button,
  .shift-view-dialog-save-btn.el-button {
    min-height: 26px !important;
    padding: 0 8px !important;
    font-size: 9px !important;
  }
}

/* Final Figma pass for the "show shifts" calendar dialog. */
.shift-view-dialog,
.shift-view-dialog.el-dialog {
  width: min(640px, calc(100vw - 40px)) !important;
  max-width: min(640px, calc(100vw - 40px)) !important;
  min-height: min(560px, calc(100vh - 56px)) !important;
  background-color: #031230 !important;
  background:
    linear-gradient(rgba(0, 108, 254, 0.22), rgba(0, 108, 254, 0.22)),
    linear-gradient(299deg, #030b1b 13.22%, #15264e 86.78%) !important;
  background-image:
    linear-gradient(rgba(0, 108, 254, 0.22), rgba(0, 108, 254, 0.22)),
    linear-gradient(299deg, #030b1b 13.22%, #15264e 86.78%) !important;
  border: 1px solid rgba(0, 195, 253, 0.18) !important;
  border-radius: 5px !important;
  box-shadow: 0 20px 52px rgba(0, 6, 19, 0.44) !important;
  display: flex !important;
  flex-direction: column !important;
}

.shift-view-dialog .el-dialog__header {
  padding: 22px 38px 6px !important;
}

.shift-view-dialog .el-dialog__body {
  padding: 0 38px 10px !important;
  flex: 1 1 auto !important;
  display: flex !important;
  align-items: stretch !important;
}

.shift-view-dialog .el-dialog__footer {
  padding: 8px 38px 24px !important;
  flex: 0 0 auto !important;
}

.shift-view-dialog .el-dialog__headerbtn {
  top: 24px !important;
  right: 30px !important;
}

.shift-view-dialog-title {
  color: #ffffff !important;
  font-size: 26px !important;
  font-weight: 700 !important;
}

.shift-view-dialog .shift-calendar--view,
.shift-view-dialog .shift-calendar--edit {
  --shift-calendar-header-gap: 10px;
  --shift-calendar-header-padding: 12px 0 18px;
  --shift-calendar-title-size: 40px;
  --shift-calendar-nav-gap: 10px;
  --shift-calendar-nav-font-size: 12px;
  --shift-calendar-nav-padding-bottom: 2px;
  --shift-calendar-weekday-font-size: 30px;
  --shift-calendar-weekday-padding-bottom: 16px;
  --shift-calendar-day-height: 74px;
  --shift-calendar-day-font-size: 42px;
  --shift-calendar-day-top-padding: 15px;
  --shift-calendar-day-top-padding-selected: 11px;
  --shift-calendar-selected-size: 50px;
  --shift-calendar-selected-font-size: 30px;
  --shift-calendar-shift-font-size: 12px;
  --shift-calendar-shift-margin-top: 4px;
  max-width: 560px;
  margin: 0 auto;
}

.shift-view-dialog .shift-calendar-header {
  align-items: flex-end !important;
}

.shift-view-dialog .shift-calendar-title {
  color: #269ff5 !important;
  font-weight: 700 !important;
}

.shift-view-dialog .shift-calendar-nav {
  gap: 11px !important;
}

.shift-view-dialog .shift-calendar-nav-btn {
  font-weight: 300 !important;
}

.shift-view-dialog .shift-calendar--view .cell-date,
.shift-view-dialog .shift-calendar--edit .cell-date {
  font-weight: 300 !important;
}

.shift-view-dialog .shift-calendar--view .cell-shift-inline,
.shift-view-dialog .shift-calendar--edit .cell-shift-inline {
  color: #00c3fd !important;
}

.shift-view-dialog-template-btn.el-button,
.shift-view-dialog-save-btn.el-button {
  border-radius: 4px !important;
  min-height: 34px !important;
  padding: 0 16px !important;
  font-size: 12px !important;
}

.shift-view-dialog-footer-actions {
  margin-top: 2px !important;
}

.shift-view-dialog .el-calendar {
  width: 100% !important;
}

@media (max-width: 768px) {
  .shift-view-dialog,
  .shift-view-dialog.el-dialog {
    width: calc(100vw - 18px) !important;
    max-width: calc(100vw - 18px) !important;
    min-height: auto !important;
  }

  .shift-view-dialog .shift-calendar--view,
  .shift-view-dialog .shift-calendar--edit {
    max-width: 100%;
    --shift-calendar-title-size: 25px;
    --shift-calendar-nav-font-size: 8px;
    --shift-calendar-nav-gap: 7px;
    --shift-calendar-weekday-font-size: 18px;
    --shift-calendar-day-height: 48px;
    --shift-calendar-day-font-size: 24px;
    --shift-calendar-selected-size: 36px;
    --shift-calendar-selected-font-size: 20px;
    --shift-calendar-shift-font-size: 7px;
    --shift-calendar-day-top-padding: 8px;
    --shift-calendar-day-top-padding-selected: 5px;
  }

  .shift-view-dialog .shift-calendar-header {
    flex-direction: row !important;
    align-items: flex-end !important;
    gap: 8px !important;
  }
}

@media (max-width: 480px) {
  .shift-view-dialog,
  .shift-view-dialog.el-dialog {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
  }

  .shift-view-dialog .el-dialog__header {
    padding: 14px 14px 4px !important;
  }

  .shift-view-dialog .el-dialog__body {
    padding: 0 14px 10px !important;
  }

  .shift-view-dialog .el-dialog__footer {
    padding: 4px 14px 12px !important;
  }

  .shift-view-dialog .shift-calendar--view,
  .shift-view-dialog .shift-calendar--edit {
    --shift-calendar-title-size: 22px;
    --shift-calendar-nav-font-size: 7px;
    --shift-calendar-weekday-font-size: 16px;
    --shift-calendar-day-height: 42px;
    --shift-calendar-day-font-size: 20px;
    --shift-calendar-selected-size: 32px;
    --shift-calendar-selected-font-size: 18px;
    --shift-calendar-day-top-padding: 6px;
    --shift-calendar-day-top-padding-selected: 4px;
  }
}
</style>

